module.exports = __webpack_public_path__ + "img/flechalinks.274b888f.svg";